import React from 'react';
import { Helmet } from 'react-helmet';
import RegistrationHeader from './components/RegistrationHeader';
import RegistrationForm from './components/RegistrationForm';
import { useLanguage } from '../../contexts/LanguageContext';

const CompanyRegistration = () => {
  const { t } = useLanguage();

  return (
    <>
      <Helmet>
        <title>Company Registration - SiteProof</title>
        <meta
          name="description"
          content="Create your SiteProof account and start managing construction site compliance across the UK. Join hundreds of construction companies tracking documents and proving site readiness."
        />
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-12">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
              <div className="space-y-6 md:space-y-8">
                <RegistrationHeader />
              </div>

              <div className="w-full">
                <div className="bg-card border border-border rounded-xl shadow-elevation-2 p-6 md:p-8 lg:p-10">
                  <RegistrationForm />
                </div>
              </div>
            </div>

            <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-border">
              <div className="text-center text-xs md:text-sm text-muted-foreground font-caption space-y-2">
                <p>
                  {t('reg.terms')}
                </p>
                <p>
                  {t('reg.copyright')?.replace('{year}', new Date()?.getFullYear())}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyRegistration;